import React, { useEffect } from "react";

export default function JobOpenings() {
  useEffect(() => {
    const revealElements = document.querySelectorAll(".reveal");
    const revealOnScroll = () => {
      revealElements.forEach((el) => {
        const rect = el.getBoundingClientRect();
        if (rect.top < window.innerHeight - 80) {
          el.classList.add("active");
        }
      });
    };

    window.addEventListener("scroll", revealOnScroll);
    revealOnScroll();
    return () => window.removeEventListener("scroll", revealOnScroll);
  }, []);

  const jobData = [
    {
      category: "Leadership & Strategy",
      roles: [
        {
          title: "Head of Operations (COO / Operations Manager)",
          desc: "Owns day-to-day execution across sales, projects, procurement, and service.",
          kpi: "On-time project delivery, margins, zero chaos."
        },
        {
          title: "Head of Projects (Project Director – Hydroponics / CEA)",
          desc: "Responsible for all farm construction projects across India.",
          kpi: "Project timelines, cost vs budget, client satisfaction."
        },
        {
          title: "Head of Agronomy & R&D (Chief Agronomist)",
          desc: "Designs crop protocols, nutrient recipes, SOPs for crops & systems.",
          kpi: "Yield, consistency, reduction in client complaints."
        },
      ]
    },

    {
      category: "Sales, Business Development & Key Accounts",
      roles: [
        {
          title: "Head of Sales (B2B / Projects)",
          desc: "Builds sales team, closes high-ticket farms, franchises & corporate deals.",
          kpi: "Monthly order booking, pipeline, conversion ratio."
        },
        {
          title: "Project Sales Managers (Regional – West / South / North)",
          desc: "Frontline closers handling 50–5000 sqm projects, plant visits & negotiations.",
          kpi: "Region-wise sales, enquiry-to-order closing %."
        },
        {
          title: "Inside Sales / Pre-Sales Executives",
          desc: "Handle inbound leads, qualify & book meetings.",
          kpi: "Contact rate, meeting conversion rate."
        },
        {
          title: "Key Account Manager (KAM – Strategic Clients)",
          desc: "Manages big-ticket clients, repeat orders, AMCs.",
          kpi: "Upsell, repeat revenue, reference projects."
        },
      ]
    },

    {
      category: " Project Execution & Site Team",
      roles: [
        {
          title: "Senior Project Manager (Hydroponic EPC)",
          desc: "Manages planning, vendors & execution from handover to commissioning.",
          kpi: "Project schedule adherence, snag-free delivery."
        },
        {
          title: "Site Engineers / Project Engineers",
          desc: "Execute structure, plumbing, electricals & automation on-site.",
          kpi: "Quality of execution, rework %, reporting discipline."
        },
        {
          title: "Structural Design Engineer",
          desc: "Designs polyhouse and greenhouse structures, foundations & steel optimization.",
          kpi: "Cost-optimized safe designs, material efficiency."
        },
        {
          title: "Irrigation & Automation Engineer",
          desc: "Designs NFT, DWC, fertigation & controllers.",
          kpi: "System reliability, failure rate, water & nutrient efficiency."
        },
        {
          title: "Site Supervisor / Foreman",
          desc: "Manages labour, targets, contractor coordination.",
          kpi: "Labour productivity, wastage control."
        },
        {
          title: "HSE Officer",
          desc: "Ensures safety, PPE compliance & legal norms.",
          kpi: "Zero accidents, safety audit scores."
        }
      ]
    },

    {
      category: "Agronomy, Training & Client Success",
      roles: [
        {
          title: "Lead Agronomist (Commercial Farms – Leafy & Fruiting)",
          desc: "Planning, crop cycles, troubleshooting for client farms.",
          kpi: "Client farm yield, disease control, renewal rate."
        },
        {
          title: "Junior Agronomists / Field Officers",
          desc: "Farm visits, crop monitoring, staff training.",
          kpi: "Farms handled, reduction in complaints."
        },
        {
          title: "Training & Extension Manager",
          desc: "Owns masterclass, farm training & corporate visits.",
          kpi: "Training revenue, NPS score."
        },
        {
          title: "Customer Success Manager",
          desc: "Single point of contact for new farm owners.",
          kpi: "Onboarding quality, AMC conversion, testimonials."
        }
      ]
    },

    {
      category: "Procurement, Supply Chain & Factory",
      roles: [
        {
          title: "Procurement Manager",
          desc: "Buys steel, pumps, fittings, nutrients, media.",
          kpi: "Cost savings, on-time availability."
        },
        {
          title: "Supply Chain & Logistics Coordinator",
          desc: "Plans dispatches, optimizes load & tracks deliveries.",
          kpi: "On-time dispatch, freight cost efficiency."
        },
        {
          title: "Warehouse & Inventory Manager",
          desc: "Manages stock across materials & ready kits.",
          kpi: "Stock accuracy, dead stock %, stockouts."
        }
      ]
    },

    {
      category: "Marketing, Brand & Content",
      roles: [
        {
          title: "Marketing Manager",
          desc: "Owns brand, campaigns & budgets.",
          kpi: "Cost per lead, brand visibility."
        },
        {
          title: "Content & Media Lead",
          desc: "Creates videos, reels, case studies, brochures.",
          kpi: "Content output, views, engagement."
        }
      ]
    },

    {
      category: "Finance, HR & Systems",
      roles: [
        {
          title: "Finance Manager / Controller",
          desc: "Handles P&L, cash flow, banking & reporting.",
          kpi: "Cash stability, collection cycle."
        },
        {
          title: "HR & Talent Acquisition Manager",
          desc: "Recruitment, KRAs, performance, culture.",
          kpi: "Time-to-hire, retention."
        },
        {
          title: "IT & Systems Manager (CRM / ERP)",
          desc: "Owns dashboards, CRM, internal tools & website.",
          kpi: "System adoption, data accuracy."
        }
      ]
    }
  ]

  return (
    <div className="bg-light">
  {/* Animation CSS */}
  <style>{`
    .reveal {
      opacity: 0;
      transform: translateY(25px);
      transition: all 0.7s cubic-bezier(0.23, 1, 0.32, 1);
    }
    .reveal.active {
      opacity: 1;
      transform: translateY(0);
    }

    .delay-1 { transition-delay: 0.1s; }
    .delay-2 { transition-delay: 0.2s; }
    .delay-3 { transition-delay: 0.3s; }
    .delay-4 { transition-delay: 0.4s; }
    .delay-5 { transition-delay: 0.5s; }
    .delay-6 { transition-delay: 0.6s; }
    .delay-7 { transition-delay: 0.7s; }
    .delay-8 { transition-delay: 0.8s; }
    .delay-9 { transition-delay: 0.9s; }

    .job-card {
      transition: all .3s ease;
      border-radius: 12px;
      background: #fff;
      border: 1px solid #e8e8e8;
    }
    .job-card:hover {
      transform: translateY(-6px);
      box-shadow: 0 8px 24px rgba(0,0,0,0.09);
    }
  `}</style>

  <div className="container-xl ">
    <h2
      className="mt-0 mb-4 fs-3 fs-md-2 fs-lg-1  fw-bold text-white p-2 rounded-3 text-center reveal"
      style={{ background: "limegreen" }}
    >
      Job Openings at Kryzen Biotech
    </h2>

    {/* Global CTA */}
    <div className="text-center mb-5 reveal delay-1">
    
    </div>

    {/* JOB DATA */}
    {jobData.map((section, idx) => (
      <div key={idx} className="mb-5 reveal delay-1">
        <h2 className="fw-bold mb-3 reveal text-center">{section.category.toLocaleUpperCase()}</h2>

        <div className="row row-deck g-4">
  {section.roles.map((role, i) => (
    /* Make the column a flex container so the card can stretch */
    <div className="col-md-6 col-lg-4 d-flex" key={i}>
      {/* Make the card a vertical flex container that grows to fill the column */}
      <div className={`card job-card p-3 reveal delay-${i + 1} d-flex flex-column flex-grow-1`}>
        <h4 className="fw-bold">{role.title}</h4>

        {/* Let the main content grow so the button is pushed down */}
        <div className="flex-grow-1">
          <p className="text-secondary" style={{ fontSize: "0.9rem" }}>
            {role.desc}
          </p>
          <p className="small text-dark">
            <strong>KPI:</strong> {role.kpi}
          </p>
        </div>

        {/* mt-auto pushes this block to the bottom of the card */}
        <div className="text-end mt-auto">
          <button
            className="btn btn-success mt-3 btn-outline w-50"
            onClick={() =>
              (window.location.href = "https://alpha.kryzen.com/career?theme=light")
            }
          >
            Apply Now →
          </button>
        </div>
      </div>
    </div>
  ))}
</div>


      </div>
    ))}

    
  </div>
</div>

  );
}


